import { useQuery } from '@apollo/client'
import {
  Collapse,
  Modal,
  Paper,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core'
import LockIcon from '@material-ui/icons/Lock'
import React, { useState } from 'react'

import SectionTitle from '../../../components/SectionTitle'
import { ALLOCATE_HISTORY } from '../../../graphql/inventoryAllocateAvailability'
import { getDirection, getTranslate } from '../../../localization'
import {
  AllocateHistoryInput,
  AllocationHistory,
  SystemReservation
} from '../../../types/inventoryAllocatedList'
import HistoryItem from './historyItem'
import useStyles from './styles/index.styles'

interface AllocationHistoryModalProps {
  isOpen: boolean
  onClose: () => void
  input: AllocateHistoryInput
}
const AllocationHistoryModal: React.FC<AllocationHistoryModalProps> = ({
  isOpen,
  onClose,
  input
}) => {
  const classes = useStyles()
  const [showDetails, setshowDetails] = useState<boolean>()
  const [details, setdetails] = useState<SystemReservation[]>([])
  const { data } = useQuery<{
    allocateHistory: AllocationHistory[]
  }>(ALLOCATE_HISTORY, {
    variables: {
      input: input
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache'
  })

  return (
    <div>
      <Modal dir={getDirection()} open={isOpen} onClose={onClose}>
        <Slide direction="down" in={isOpen}>
          <Paper className={classes.paper}>
            <div className={classes.container}>
              <div className={classes.historiesContainer}>
                <div className={classes.titleContainer}>
                  <SectionTitle title="Allocation History" marginBottom />
                </div>
                {data?.allocateHistory.map((history, index) => (
                  <HistoryItem
                    history={history}
                    onDetailsClick={(d: SystemReservation[]) => {
                      setshowDetails(true)
                      setdetails(d)
                    }}
                    lastIndex={index === data.allocateHistory.length - 1}
                  />
                ))}
              </div>{' '}
              {showDetails && (
                <Collapse
                  in={showDetails}
                  className={classes.collapseContainer}>
                  <div className={classes.titleContainer}>
                    <div
                      className={`${classes.iconWrapper} ${classes.allocateIcon}`}>
                      <LockIcon />
                    </div>
                    <SectionTitle title="Reservation Numbers" marginBottom />
                  </div>
                  <TableContainer>
                    <Table className={classes.table} size="small">
                      <TableHead className={classes.tableHeader}>
                        <TableRow>
                          <TableCell>
                            {getTranslate('Reservation Num')}
                          </TableCell>
                          <TableCell>{getTranslate('Date')}</TableCell>
                          <TableCell>{getTranslate('Type')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {details.map((reservation, index) => (
                          <TableRow key={index}>
                            <TableCell>
                              {reservation.reservationNumber}
                            </TableCell>
                            <TableCell>{reservation.time}</TableCell>
                            <TableCell>
                              {getTranslate(reservation.operationType)}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Collapse>
              )}
            </div>
          </Paper>
        </Slide>
      </Modal>
    </div>
  )
}

export default AllocationHistoryModal
